export default "__VITE_ASSET__c4f68e7d__"